module.exports = __webpack_public_path__ + "img/blur_2.00cacde4.jpg";